export default __webpack_public_path__ + "static/media/mail-generic.e136e037.svg";